import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import type { CheckboxProps as CheckboxDaisyProps } from "react-daisyui";
import { twMerge } from "tailwind-merge";

type CheckboxInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "color" | "size">;

export interface CheckboxProps extends CheckboxInputProps {
  label?: string | ReactNode;
  error?: string;
  size?: CheckboxDaisyProps["size"];
  color?: CheckboxDaisyProps["color"];
  required?: boolean;
  labelClassName?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, required, size, color, labelClassName, className, id, ...props }, ref) => {
    const inputClasses = twMerge(
      "checkbox",
      size && `checkbox-${size}`,
      color && `checkbox-${color}`,
      error && "checkbox-error",
    );
    const labelClasses = twMerge("label-text ml-2.5 [&>a]:underline [&>a]:text-dodger-blue-700", labelClassName);

    return (
      <div className="form-control relative">
        <label className="label cursor-pointer justify-start" htmlFor={id}>
          <input type="checkbox" className={inputClasses} ref={ref} id={id} {...props} />
          {label && (
            <span className={labelClasses}>
              {label} {required && "*"}
            </span>
          )}
        </label>
        {error && (
          <label className="label absolute -bottom-2 p-0" htmlFor={id}>
            <span className="label-text-alt text-error">{error}</span>
          </label>
        )}
      </div>
    );
  },
);
